import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { RouterContext } from '@/App';

// Root route con context tipado (auth). El Outlet renderiza la subruta activa.
// V1 NO incluye devtools en runtime — para evitar inflar el bundle. Si quisieras agregarlos,
// envolvé el Outlet en <TanStackRouterDevtools /> guardado detrás de import.meta.env.DEV.

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent(): JSX.Element {
  return <Outlet />;
}
